<template>
    <div>
        <v-dialog :value="!!data.id" lazy>
            <v-card v-if="!!data.id">
                <v-card-title primary-title class="title font-weight-bold text-xs-center white--text green">
                    <v-spacer/>
                    Reminder: Time Suggestion (Change Time)
                    <v-spacer/>
                    <v-progress-circular
                            :size="50"
                            :width="5"
                            :value="time"
                            color="beige"
                    >
                        {{time}}
                    </v-progress-circular>
                    <v-spacer/>

                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-layout row wrap class="title">
                        <v-flex xs6 class="font-weight-bold">
                            Passenger Name:
                        </v-flex>
                        <v-flex xs6>
                            {{data.passenger_name}}
                        </v-flex>
                        <v-flex xs6 class="font-weight-bold">
                            Passenger Whatsapp:
                        </v-flex>
                        <v-flex xs6>
                            {{data.passenger_whatsapp}}
                        </v-flex>
                        <v-flex xs6 class="font-weight-bold">
                            Captain Name:
                        </v-flex>
                        <v-flex xs6>
                            {{data.captain_name}}
                        </v-flex>
                        <v-flex xs6 class="font-weight-bold">
                            Original Time:
                        </v-flex>
                        <v-flex xs6>
                            {{ formatCompanyTime(data.original_time, "HH:mm") }}
                        </v-flex>
                        <v-flex xs6 class="font-weight-bold">
                            New Time:
                        </v-flex>
                        <v-flex xs6>
                            {{ formatCompanyTime(data.new_time, "HH:mm") }}
                        </v-flex>

                    </v-layout>
                </v-card-text>
                <div class="actions">
                    <v-btn color="primary" large class="title" @click="pass">
                        The passenger said ok
                    </v-btn>
                    <v-btn color="error" large class="title" @click="decline">
                        The passenger said NO
                    </v-btn>
                    <v-btn color="light-green" large class="title" @click="snooze">
                        No response yet
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>

</template>

<script>
    import { formatCompanyTime, toCompanyMoment, companyNow } from "@/util/companyTime";
    import popup from "@/assets/popup.mp3";
    import hasIntervalsMixin from "@/mixins/hasIntervalsMixin";

    export default {
        mixins: [hasIntervalsMixin],
        name: "suggest-popup",
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                map: null,
                time: 150
            }
        },
        mounted() {
            // (new Audio(popup)).play();
        },
        intervals() {
            return [
                [this.updateTime, 1000]
            ]
        },
        methods: {
            pass() {
                this.axios.post(`booking/${this.data.id}/confirm_suggestion`);
            },
            decline() {
                this.axios.post(`booking/${this.data.id}/refuse_suggestion`);
            },
            snooze() {
                this.$emit("snooze");
            },
            updateTime() {
                const until = toCompanyMoment(this.data.countdown_until);
                if (!until) {
                    return;
                }
                // Final-version doc 2026-10-05: instant compare, not PC time.
                this.time = until.diff(companyNow(), 'seconds');
                if (this.time <= 0)
                    this.snooze();
            }
        }
    }
</script>

<style lang="scss" scoped>

    .actions {
        padding: 8px;
        display: flex;
        justify-content: space-evenly;
        background-color: white;
        width: 100%;
    }

</style>
